/**
 * Sanitizes a search value by trimming whitespace, removing parentheses and returning empty string for invalid values
 * @param value - The search value to sanitize
 * @returns Empty string if value is null/undefined/whitespace-only/parenthesis, otherwise the original value
 */
const PARENTHESIS_REGEX = /[()]/g

export const sanitizeSearchValue = (value: string): string =>
  value.length
    ? (isEmptyOrWhitespace(value) ? value.trim() : value).replace(PARENTHESIS_REGEX, '')
    : value

/**
 * Checks if a value is empty or contains only whitespace
 * @param value - The value to check
 * @returns true if value is empty, null, undefined, or whitespace-only
 */
export const isEmptyOrWhitespace = (value: string | null | undefined): boolean => {
  return !value || value.trim() === ''
}
